import { NgModule } from '@angular/core';
import { AddressSuggestPluginComponent } from './address-suggest-plugin.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [AddressSuggestPluginComponent],
  exports: [AddressSuggestPluginComponent],
  imports: [CommonModule, HttpClientModule],
})
export class AddressSuggestPluginModule {}
